import { defineMessages } from 'react-intl'

export default defineMessages({
  team: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.team',
    defaultMessage: 'Team',
  },
  purchaseOrder: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.purchaseOrder',
    defaultMessage: 'P.O.',
  },
  date: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.date',
    defaultMessage: 'Date',
  },
  expectedDelivery: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.expectedDelivery',
    defaultMessage: 'Delivery',
  },
  stage: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.stage',
    defaultMessage: 'Stage',
  },
  contact: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.contact',
    defaultMessage: 'Contact',
  },
  orderName: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.orderName',
    defaultMessage: 'Name',
  },
  usageRights: {
    id: 'containers.CustomerOrdersPages.components.OrderHeadRow.usageRights',
    defaultMessage: 'Usage Rights',
  },
})
